var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span ng-if=\"vm.get_displayvalue(vm.parameter[vm.key].wert)\">{{ vm.get_displayvalue(vm.parameter[vm.key].wert) }}</span><span ng-if=\"!vm.get_displayvalue(vm.parameter[vm.key].wert)\">Keine Angabe</span>");;return buf.join("");
}